export default __webpack_public_path__ + "0e753e12ecb30674b0f955b635dd4522.svg";